import './Listing';
import './Form';

import ShiftPlanModalForm from "./modals/ShiftPlanModalForm";
import ShiftPlanCalendar from "./widgets/ShiftPlanCalendar";
import DropdownMonths from '../components/basic/DropdownMonths';
import ShiftPlanEmbedForm from "./modals/ShiftPlanEmbedForm.vue";

Vue.component('shift-plan-modal-form', ShiftPlanModalForm);
Vue.component('shift-plan-embed-form', ShiftPlanEmbedForm);
Vue.component('shift-plan-calendar', ShiftPlanCalendar);
Vue.component('dropdown-months', DropdownMonths);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/shift-plan/index.js